import { useEffect, useState } from 'react';
import { Beaker, Lock, Sparkles } from 'lucide-react';

type EnvBadge = {
  key: string;
  label: string;
  bg: string;
  icon: React.ReactNode;
};

const PRIORITY: Record<string, number> = { admin: 3, staging: 2, beta: 1 };

export function EnvironmentRibbon({ isAdmin = false }: { isAdmin?: boolean }) {
  const [isStaging, setIsStaging] = useState(false);

  useEffect(() => {
    setIsStaging(window.location.hostname.includes('.staging.'));
  }, []);

  const badges: EnvBadge[] = [];

  if (isAdmin) {
    badges.push({
      key: 'admin',
      label: 'ADMIN',
      bg: 'bg-red-500',
      icon: <Lock className="w-3 h-3" />,
    });
  }

  if (isStaging) {
    badges.push({
      key: 'staging',
      label: 'STAGING',
      bg: 'bg-amber-500',
      icon: <Beaker className="w-3 h-3" />,
    });
  }

  badges.push({
    key: 'beta',
    label: 'BETA',
    bg: 'bg-gradient-to-r from-violet-500 to-indigo-600',
    icon: <Sparkles className="w-3 h-3" />,
  });

  const topColor = badges.reduce(
    (best, b) => ((PRIORITY[b.key] ?? 0) > (PRIORITY[best] ?? 0) ? b.key : best),
    badges[0]?.key ?? 'beta',
  );

  const borderMap: Record<string, string> = {
    admin: 'border-t-red-500',
    staging: 'border-t-amber-500',
    beta: 'border-t-violet-500',
  };

  return (
    <div
      className={`fixed top-0 left-0 w-full z-[100] border-t-4 ${borderMap[topColor]} pointer-events-none`}
    >
      <div className="absolute top-0 right-2 flex items-start gap-1 pointer-events-auto">
        {badges.map((b) => (
          <span
            key={b.key}
            className={`text-sm text-white px-2 pb-0.5 rounded-b flex items-center justify-center gap-1.5 ${b.bg}`}
          >
            {b.icon} {b.label}
          </span>
        ))}
      </div>
    </div>
  );
}
